import { useState, useEffect, useRef } from 'react';

function getWindowDimensions() {
  // eslint-disable-next-line no-undef
  const { innerWidth: width, innerHeight: height } = window;

  return {
    width,
    height,
  };
}

export default function useWindowDimensions() {
  const initialRef = useRef();

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    const initial = getWindowDimensions();
    setWindowDimensions(initial);
    initialRef.current = initial;

    const handleResize = () => {
      setWindowDimensions(getWindowDimensions());
    };

    // eslint-disable-next-line no-undef
    window.addEventListener('resize', handleResize);
    // eslint-disable-next-line no-undef
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return { ...windowDimensions, initial: initialRef.current };
}
